import type { Module } from 'vuex';
import { UserAccount } from '@/types/UserAccount';
import {RootState} from "@/store";

export interface UserAccountState {
  userAccounts: UserAccount[];
  userAccountTypes: string[];
}

const userAccountModule: Module<UserAccountState, RootState> = {
  namespaced: true,

  state: (): UserAccountState => ({
    userAccounts: [],
    userAccountTypes: [],
  }),

  getters: {
    getById: (state) => (id: number): UserAccount | undefined => {
      return state.userAccounts.find(userAccount => userAccount.idUserAccount === id);
    },
    allTypes: (state): string[] => state.userAccountTypes,
  },

  mutations: {
    setUserAccounts(
      state,
      payload: {
        userAccounts: Record<number, any>;
        userAccountTypes: string[];
      }
    ) {
      state.userAccounts = Object
        .values(payload.userAccounts)
        .map(UserAccount.fromRaw);
      state.userAccountTypes = payload.userAccountTypes;
    },

    setUserAccountCreate(
      state,
      payload: {
        idUserAccount: number;
        idUser: number;
        type: string;
        title: string;
      }
    ) {
      const raw = {
        idUserAccount: payload.idUserAccount,
        idUser: payload.idUser,
        type: payload.type,
        title: payload.title,
      };
      state.userAccounts.push(UserAccount.fromRaw(raw));
    },

    setUserAccountUpdate(
      state,
      payload: {
        idUserAccount: number;
        type?: string;
        title?: string;
      }
    ) {
      const userAccount = state.userAccounts.find(
        userAccount => userAccount.idUserAccount === payload.idUserAccount
      );
      if (!userAccount) return;
      if (payload.type !== undefined)  userAccount.type  = payload.type;
      if (payload.title !== undefined) userAccount.title = payload.title;
    },

    setUserAccountDelete(
      state,
      payload: { idUserAccount: number }
    ) {
      state.userAccounts = state.userAccounts.filter(
        userAccount => userAccount.idUserAccount !== payload.idUserAccount
      );
    },
  },

  actions: {
    wsSetUserAccounts({ commit }, payload) {
      commit('setUserAccounts', payload);
    },
    wsUserAccountCreate({ commit }, payload) {
      commit('setUserAccountCreate', payload);
    },
    wsUserAccountUpdate({ commit }, payload) {
      commit('setUserAccountUpdate', payload);
    },
    wsUserAccountDelete({ commit }, payload) {
      commit('setUserAccountDelete', payload);
    },
  },
};

export default userAccountModule;
